import React, { useState } from 'react';

const PIN = process.env.REACT_APP_SECOND_ADMIN_PIN ;

export default function AdminGate({ children }) {
  const [ok, setOk] = useState(() => localStorage.getItem('admin_pin_ok') === '1');
  const [pin, setPin] = useState('');
  const [err, setErr] = useState('');

  if (ok) return children;

  const submit = (e) => {
    e.preventDefault();
    if (PIN && pin === PIN) {
      localStorage.setItem('admin_pin_ok', '1');
      setOk(true);
    } else {
      setErr('Invalid admin PIN');
    }
  };

  return (
    <div className="container py-5">
      <div className="mx-auto" style={{ maxWidth: 420 }}>
        <h3 className="mb-3">Admin Access</h3>
        <p className="text-muted mb-4">Enter the admin PIN to continue.</p>
        <form onSubmit={submit} className="d-grid gap-3">
          <input
            type="password"
            className="form-control"
            placeholder="Admin PIN"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
          />
          {err && <div className="text-danger small">{err}</div>}
          <button className="btn btn-dark" type="submit" style={{ cursor: 'pointer' }}>
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}
